export default __webpack_public_path__ + "static/media/Pyramide-besoins_perso_n5_accomplissement.cc50d7fc.svg";